import { AiOutlineMail } from "react-icons/ai";
import {
  BsCurrencyExchange,
  BsGearWideConnected,
  BsReverseLayoutTextWindowReverse,
} from "react-icons/bs";
import { FcWorkflow } from "react-icons/fc";
import { MdSettings } from "react-icons/md";

export const settingsMenu = {
  REMITTANCE: [
    {
      id: 1,
      to: "/settings/rates",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsCurrencyExchange color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Rates",
      lingualText: "para_exchange_rate",
    },
    {
      id: 2,
      to: "/settings/bank-account-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsReverseLayoutTextWindowReverse
          color={"#6259CA"}
          fontSize={24}
          fill={"#6259CA"}
        />
      ),
      text: "Bank Account Fields",
      lingualText: "WO_BANK_ACCOUNT_SETTING_1025629397",
    },
    {
      id: 3,
      to: "/settings/remittance-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Remmittance Fee",
      lingualText: "m_manage_money_transfer_commission",
    },
    {
      id: 4,
      to: "/settings/interest-rate",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Account maintenance fee",
      lingualText: "WO_INTEREST_RAT_1193574154",
    },
    {
      id: 5,
      to: "/settings/workflow",
      icon: "fa fa-file-invoice",
      iconSvg: <FcWorkflow color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Workflow",
      lingualText: "WO_WORKFLO_-434837466",
    },
    {
      id: 6,
      to: "/settings/remittance-fee-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Remittance Settings",
      lingualText: "WO_REMITTANCE_SETTING_-1350168954",
    },
    {
      id: 7,
      to: "/settings/brand-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Brand Settings",
      lingualText: "m_visual_settings",
    },
    {
      id: 8,
      to: "/settings/email-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <AiOutlineMail color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Email Settings",
      lingualText: "WO_EMAIL_SETTING_2052406034",
    },
    {
      id: 9,
      to: "/settings/mobile-app-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Mobile App Settings",
      lingualText: "WO_MOBILE_APP_SETTING_105909637",
    },
  ],
  DIGITAL_BANKING: [
    {
      id: 1,
      to: "/settings/brand-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Brand Settings",
      lingualText: "m_visual_settings",
    },
    {
      id: 2,
      to: "/settings/email-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <AiOutlineMail color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Email Settings",
      lingualText: "WO_EMAIL_SETTING_2052406034",
    },
    {
      id: 3,
      to: "/settings/mobile-app-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Mobile App Settings",
      lingualText: "WO_MOBILE_APP_SETTING_105909637",
    },
    {
      id: 4,
      to: "/settings/remittance-fee-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Remittance Settings",
      lingualText: "WO_REMITTANCE_SETTING_-1350168954",
    },
    {
      id: 5,
      to: "/settings/workflow",
      icon: "fa fa-file-invoice",
      iconSvg: <FcWorkflow color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Workflow",
      lingualText: "WO_WORKFLO_-434837466",
    },
  ],
  PAY_OUT_PARTNER: [
    {
      id: 1,
      to: "/settings/workflow",
      icon: "fa fa-file-invoice",
      iconSvg: <FcWorkflow color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Workflow",
      lingualText: "WO_WORKFLO_-434837466",
    },
  ],
  ELECTRONIC_MONEY_SERVICES: [
    {
      id: 1,
      to: "/settings/brand-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Brand Settings",
      lingualText: "m_visual_settings",
    },
    {
      id: 2,
      to: "/settings/email-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <AiOutlineMail color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Email Settings",
      lingualText: "WO_EMAIL_SETTING_2052406034",
    },
    {
      id: 3,
      to: "/settings/mobile-app-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Mobile App Settings",
      lingualText: "WO_MOBILE_APP_SETTING_105909637",
    },
    {
      id: 4,
      to: "/settings/remittance-fee-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Remittance Settings",
      lingualText: "WO_REMITTANCE_SETTING_-1350168954",
    },
    {
      id: 5,
      to: "/settings/workflow",
      icon: "fa fa-file-invoice",
      iconSvg: <FcWorkflow color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Workflow",
      lingualText: "WO_WORKFLO_-434837466",
    },
  ],
  LENDING: [
    {
      id: 1,
      to: "/settings/brand-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Brand Settings",
      lingualText: "m_visual_settings",
    },
    {
      id: 2,
      to: "/settings/email-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <AiOutlineMail color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Email Settings",
      lingualText: "WO_EMAIL_SETTING_2052406034",
    },
    {
      id: 3,
      to: "/settings/mobile-app-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Mobile App Settings",
      lingualText: "WO_MOBILE_APP_SETTING_105909637",
    },
    {
      id: 4,
      to: "/settings/remittance-fee-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Remittance Settings",
      lingualText: "WO_REMITTANCE_SETTING_-1350168954",
    },
    {
      id: 5,
      to: "/settings/workflow",
      icon: "fa fa-file-invoice",
      iconSvg: <FcWorkflow color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Workflow",
      lingualText: "WO_WORKFLO_-434837466",
    },
  ],
  WALLET_ACCOUNT_MANAGEMENT: [
    {
      id: 1,
      to: "/settings/brand-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Brand Settings",
      lingualText: "m_visual_settings",
    },
    {
      id: 2,
      to: "/settings/email-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <AiOutlineMail color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Email Settings",
      lingualText: "WO_EMAIL_SETTING_2052406034",
    },
    {
      id: 3,
      to: "/settings/mobile-app-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Mobile App Settings",
      lingualText: "WO_MOBILE_APP_SETTING_105909637",
    },
    {
      id: 4,
      to: "/settings/remittance-fee-settings",
      icon: "fa fa-file-invoice",
      iconSvg: (
        <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
      ),
      text: "Remittance Settings",
      lingualText: "WO_REMITTANCE_SETTING_-1350168954",
    },
    {
      id: 5,
      to: "/settings/workflow",
      icon: "fa fa-file-invoice",
      iconSvg: <FcWorkflow color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Workflow",
      lingualText: "WO_WORKFLO_-434837466",
    },
  ],
};

export const securityMenu = {
  REMITTANCE: [
    {
      id: 1,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "IP Whitelisting",
      lingualText: "WO_IP_ADDRESS_RESTRICTI_-421114094",
    },
    {
      id: 2,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Two Factor Authentication",
      lingualText: "WO_TWO_FACTOR_AUTHENTIC_-1180686726",
    },
    {
      id: 3,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Strong Customer Authentication",
      lingualText: "WO_ENABLE_STRONG_CUSTOM_-1835724157",
    },
    {
      id: 4,
      to: "/security/password-policy",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Password Policy",
      lingualText: "WO_PASSWORD_POLIC_-261182106",
    },
    {
      id: 5,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Enable Transaction Pin",
      lingualText: "WO_ENABLE_TRANSACTION_P_1460895606",
    },
  ],
  DIGITAL_BANKING: [
    {
      id: 1,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "IP Whitelisting",
      lingualText: "WO_IP_ADDRESS_RESTRICTI_-421114094",
    },
    {
      id: 2,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Two Factor Authentication",
      lingualText: "WO_TWO_FACTOR_AUTHENTIC_-1180686726",
    },
    {
      id: 3,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Strong Customer Authentication",
      lingualText: "WO_ENABLE_STRONG_CUSTOM_-1835724157",
    },
    {
      id: 4,
      to: "/security/password-policy",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Password Policy",
      lingualText: "WO_PASSWORD_POLIC_-261182106",
    },
    {
      id: 5,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Enable Transaction Pin",
      lingualText: "WO_ENABLE_TRANSACTION_P_1460895606",
    },
  ],
  PAY_OUT_PARTNER: [],
  ELECTRONIC_MONEY_SERVICES: [
    {
      id: 1,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "IP Whitelisting",
      lingualText: "WO_IP_ADDRESS_RESTRICTI_-421114094",
    },
    {
      id: 2,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Two Factor Authentication",
      lingualText: "WO_TWO_FACTOR_AUTHENTIC_-1180686726",
    },
    {
      id: 3,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Strong Customer Authentication",
      lingualText: "WO_ENABLE_STRONG_CUSTOM_-1835724157",
    },
    {
      id: 4,
      to: "/security/password-policy",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Password Policy",
      lingualText: "WO_PASSWORD_POLIC_-261182106",
    },
    {
      id: 5,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Enable Transaction Pin",
      lingualText: "WO_ENABLE_TRANSACTION_P_1460895606",
    },
  ],
  LENDING: [
    {
      id: 1,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "IP Whitelisting",
      lingualText: "WO_IP_ADDRESS_RESTRICTI_-421114094",
    },
    {
      id: 2,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Two Factor Authentication",
      lingualText: "WO_TWO_FACTOR_AUTHENTIC_-1180686726",
    },
    {
      id: 3,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Strong Customer Authentication",
      lingualText: "WO_ENABLE_STRONG_CUSTOM_-1835724157",
    },
    {
      id: 4,
      to: "/security/password-policy",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Password Policy",
      lingualText: "WO_PASSWORD_POLIC_-261182106",
    },
    {
      id: 5,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Enable Transaction Pin",
      lingualText: "WO_ENABLE_TRANSACTION_P_1460895606",
    },
  ],
  WALLET_ACCOUNT_MANAGEMENT: [
    {
      id: 1,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "IP Whitelisting",
      lingualText: "WO_IP_ADDRESS_RESTRICTI_-421114094",
    },
    {
      id: 2,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Two Factor Authentication",
      lingualText: "WO_TWO_FACTOR_AUTHENTIC_-1180686726",
    },
    {
      id: 3,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Strong Customer Authentication",
      lingualText: "WO_ENABLE_STRONG_CUSTOM_-1835724157",
    },
    {
      id: 4,
      to: "/security/password-policy",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Password Policy",
      lingualText: "WO_PASSWORD_POLIC_-261182106",
    },
    {
      id: 5,
      to: "/security/security-settings",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Enable Transaction Pin",
      lingualText: "WO_ENABLE_TRANSACTION_P_1460895606",
    },
  ],
};

export const plugInMenu = {
  REMITTANCE: [
    {
      id: 1,
      to: "/plugins/payout-api/add-payout-api",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Add Pay-out API",
      lingualText: "WO_ADD_NEW_PLUGI_1498103904",
    },
    {
      id: 2,
      to: "/plugins/payout-api/add-new-partner",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Add New Partner API",
      lingualText: "WO_ADD_NEW_PARTNER_AP_-2120561841",
    },
  ],
  DIGITAL_BANKING: [
    {
      id: 1,
      to: "/plugins/payout-api/add-payout-api",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Add Pay-out API",
      lingualText: "WO_ADD_NEW_PLUGI_1498103904",
    },
  ],
  PAY_OUT_PARTNER: [
    {
      id: 1,
      to: "/plugins/payout-api/add-payout-api",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Add Pay-out API",
      lingualText: "WO_ADD_NEW_PLUGI_1498103904",
    },
  ],
  ELECTRONIC_MONEY_SERVICES: [
    {
      id: 1,
      to: "/plugins/payout-api/add-payout-api",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Add Pay-out API",
      lingualText: "WO_ADD_NEW_PLUGI_1498103904",
    },
  ],
  LENDING: [],
  WALLET_ACCOUNT_MANAGEMENT: [
    {
      id: 1,
      to: "/plugins/payout-api/add-payout-api",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Add Pay-out API",
      lingualText: "WO_ADD_NEW_PLUGI_1498103904",
    },
  ],
};

export const userTypeMap = {
  CASHIER: {},
  INDIVIDUAL: {},
  REGISTERED_CUSTOMER: {},
  BRANCH_ADMINS: {},
  MANAGER: {},
};

export const settingsMenu2 = [
  {
    id: 1,
    to: "/settings/rates",
    icon: "fa fa-file-invoice",
    iconSvg: (
      <BsCurrencyExchange color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
    ),
    text: "Rates",
    lingualText: "para_exchange_rate",
  },
  {
    id: 2,
    to: "/settings/bank-account-settings",
    icon: "fa fa-file-invoice",
    iconSvg: (
      <BsReverseLayoutTextWindowReverse
        color={"#6259CA"}
        fontSize={24}
        fill={"#6259CA"}
      />
    ),
    text: "Bank Account Fields",
    lingualText: "WO_BANK_ACCOUNT_SETTING_1025629397",
  },
  {
    id: 3,
    to: "/settings/remittance-settings",
    icon: "fa fa-file-invoice",
    iconSvg: (
      <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
    ),
    text: "Remmittance Fee",
    lingualText: "m_manage_money_transfer_commission",
  },
  {
    id: 4,
    to: "/settings/interest-rate",
    icon: "fa fa-file-invoice",
    iconSvg: (
      <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
    ),
    text: "Account maintenance fee",
    lingualText: "WO_INTEREST_RAT_1193574154",
  },
  {
    id: 5,
    to: "/settings/workflow",
    icon: "fa fa-file-invoice",
    iconSvg: <FcWorkflow color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
    text: "Workflow",
    lingualText: "WO_WORKFLO_-434837466",
  },
  {
    id: 6,
    to: "/settings/remittance-fee-settings",
    icon: "fa fa-file-invoice",
    iconSvg: (
      <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
    ),
    text: "Remittance Settings",
    lingualText: "WO_REMITTANCE_SETTING_-1350168954",
  },
  {
    id: 7,
    to: "/settings/brand-settings",
    icon: "fa fa-file-invoice",
    iconSvg: (
      <BsGearWideConnected color={"#6259CA"} fontSize={24} fill={"#6259CA"} />
    ),
    text: "Brand Settings",
    lingualText: "m_visual_settings",
  },
  {
    id: 8,
    to: "/settings/email-settings",
    icon: "fa fa-file-invoice",
    iconSvg: <AiOutlineMail color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
    text: "Email Settings",
    lingualText: "WO_EMAIL_SETTING_2052406034",
  },
];

export const plugInMenu2 = [
  {
    id: 1,
    to: "/plugins/payout-api/add-payout-api",
    icon: "fa fa-file-invoice",
    iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
    text: "Add Pay-out API",
    lingualText: "WO_ADD_NEW_PLUGI_1498103904",
  },
];

export const securityMenu2 = [
  {
    id: 1,
    to: "/security/security-settings",
    icon: "fa fa-file-invoice",
    iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
    text: "IP Whitelisting",
    lingualText: "WO_IP_ADDRESS_RESTRICTI_-421114094",
  },
  {
    id: 2,
    to: "/security/security-settings",
    icon: "fa fa-file-invoice",
    iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
    text: "Two Factor Authentication",
    lingualText: "WO_TWO_FACTOR_AUTHENTIC_-1180686726",
  },
  {
    id: 3,
    to: "/security/security-settings",
    icon: "fa fa-file-invoice",
    iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
    text: "Strong Customer Authentication",
    lingualText: "WO_ENABLE_STRONG_CUSTOM_-1835724157",
  },
  {
    id: 4,
    to: "/security/security-settings",
    icon: "fa fa-file-invoice",
    iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
    text: "Password Policy",
    lingualText: "WO_PASSWORD_POLIC_-261182106",
  },
  {
    id: 5,
    to: "/security/security-settings",
    icon: "fa fa-file-invoice",
    iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
    text: "Enable Transaction Pin",
    lingualText: "WO_ENABLE_TRANSACTION_P_1460895606",
  },
];
